/*!
 * Keplin — Notify Me (Back-in-Stock)
 * Posts to the Keplin MCP Worker /oos/subscribe endpoint.
 * Handles: modal, variant tracking (product page), login prompt.
 * Config injected by theme.liquid via window.__KEPLIN_OOS_CONFIG.
 * No external dependencies. ES2017+.
 */
(function () {
  'use strict';

  var CFG      = window.__KEPLIN_OOS_CONFIG || { url: 'http://127.0.0.1:8787/oos/subscribe', auth: '' };
  var CUSTOMER = window.__KEPLIN_CUSTOMER   || null; // { id, email } if logged in
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  var lastFocused = null;
  var activeData  = {};

  // ── Styles ───────────────────────────────────────────────────────────────
  var style = document.createElement('style');
  style.setAttribute('data-keplin-oos', '');
  style.textContent = [
    '[data-km-modal]{position:fixed;inset:0;z-index:99999;display:none;align-items:center;justify-content:center;padding:16px;background:rgba(20,20,20,0);transition:background .25s ease;font-family:inherit;color:#1a1a1a;}',
    '[data-km-modal].is-open{display:flex;background:rgba(20,20,20,.5);backdrop-filter:blur(2px);-webkit-backdrop-filter:blur(2px);}',
    '[data-km-modal] .km-card{background:#fff;width:100%;max-width:440px;border-radius:12px;box-shadow:0 12px 48px rgba(0,0,0,.18);padding:32px;position:relative;transform:translateY(12px) scale(.98);opacity:0;transition:transform .28s cubic-bezier(.16,.84,.44,1),opacity .2s ease;}',
    '[data-km-modal].is-open .km-card{transform:none;opacity:1;}',
    '[data-km-modal] .km-close{position:absolute;top:14px;right:14px;width:32px;height:32px;border:0;background:transparent;cursor:pointer;border-radius:6px;display:flex;align-items:center;justify-content:center;color:#888;font-size:18px;line-height:1;}.km-close svg{padding:0px !important;--buttons-padding:0px !important}',
    '[data-km-modal] .km-close:hover{background:#f3f3f1;color:#1a1a1a;}',
    '[data-km-modal] .km-eyebrow{font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:#7a7a78;font-weight:600;margin:0 0 8px;}',
    '[data-km-modal] .km-title{margin:0 0 6px;font-size:20px;line-height:1.3;font-weight:600;letter-spacing:-.01em;padding-right:24px;}',
    '[data-km-modal] .km-variant{margin:0 0 20px;font-size:14px;color:#5c5c5a;}',
    '[data-km-modal] .km-variant:empty{display:none;}',
    '[data-km-modal] .km-label{display:block;font-size:13px;color:#3a3a3a;margin-bottom:6px;font-weight:500;}',
    '[data-km-modal] .km-input{width:100%;padding:12px 14px;border:1px solid #d9d8d4;border-radius:8px;font-size:15px;background:#fff;color:#1a1a1a;box-sizing:border-box;transition:border-color .15s;font-family:inherit;}',
    '[data-km-modal] .km-input:focus{outline:0;border-color:#1a1a1a;box-shadow:0 0 0 3px rgba(26,26,26,.08);}',
    '[data-km-modal] .km-input.is-error{border-color:#c33;}',
    '[data-km-modal] .km-error{margin:6px 0 0;color:#c33;font-size:13px;min-height:16px;}',
    '[data-km-modal] .km-submit{margin-top:14px;width:100%;padding:14px;background:#1a1a1a;color:#fff;border:0;border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;transition:background .15s;font-family:inherit;letter-spacing:.01em;}',
    '[data-km-modal] .km-submit:hover:not(:disabled){background:#000;}',
    '[data-km-modal] .km-submit:disabled{opacity:.65;cursor:wait;}',
    '[data-km-modal] .km-fine{margin:10px 0 0;font-size:11px;color:#9a9a98;text-align:center;}',
    '[data-km-modal] .km-state{display:none;text-align:center;padding:8px 0;}',
    '[data-km-modal] .km-state.is-on{display:block;}',
    '[data-km-modal] .km-state-icon{width:48px;height:48px;border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 12px;font-size:22px;font-weight:700;}',
    '[data-km-modal] .km-state-icon--ok{background:#e6f4ec;color:#0d8756;}',
    '[data-km-modal] .km-state-icon--info{background:#eff1f6;color:#3a3a3a;}',
    '[data-km-modal] .km-state-title{margin:0 0 4px;font-size:17px;font-weight:600;}',
    '[data-km-modal] .km-state-sub{margin:0 0 16px;font-size:14px;color:#666;}',
    '[data-km-modal] .km-login-btn{display:inline-block;padding:10px 20px;background:#1a1a1a;color:#fff;border-radius:6px;font-size:14px;font-weight:600;text-decoration:none;font-family:inherit;}',
    '[data-km-modal] .km-login-btn:hover{background:#000;}',
    '@media(max-width:520px){[data-km-modal]{align-items:flex-end;padding:0;}[data-km-modal] .km-card{max-width:100%;border-radius:14px 14px 0 0;padding:28px 24px 36px;transform:translateY(24px);}[data-km-modal].is-open .km-card{transform:none;}}',
    '@media(prefers-reduced-motion:reduce){[data-km-modal],[data-km-modal] .km-card{transition:none;}}',
  ].join('');
  document.head.appendChild(style);

  // ── Modal markup ─────────────────────────────────────────────────────────
  var modal = document.createElement('div');
  modal.setAttribute('data-km-modal', '');
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-labelledby', 'km-title');
  modal.innerHTML =
    '<div class="km-card" role="document">' +
      '<span type="button" class="km-close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
      '</span>' +
      '<p class="km-eyebrow">Back in stock alert</p>' +
      '<span id="km-title" class="km-title"></span>' +
      '<p class="km-variant" id="km-variant"></p>' +
      '<form class="km-form" novalidate>' +
        '<label class="km-label" for="km-email">Email address</label>' +
        '<input id="km-email" class="km-input" type="email" inputmode="email" autocomplete="email" placeholder="Enter your Email Id" required />' +
        '<p class="km-error" role="alert" aria-live="polite"></p>' +
        '<button type="submit" class="km-submit">Notify me</button>' +
        '<p class="km-fine">One-off email when it\'s back — no marketing.</p>' +
      '</form>' +
      '<div class="km-state km-success">' +
        '<div class="km-state-icon km-state-icon--ok">✓</div>' +
        '<p class="km-state-title">You\'re on the list!</p>' +
        '<p class="km-state-sub">We\'ll email you the moment it\'s back in stock.</p>' +
        '<div class="km-login-wrap"></div>' +
      '</div>' +
      '<div class="km-state km-already">' +
        '<div class="km-state-icon km-state-icon--info">i</div>' +
        '<p class="km-state-title">Already signed up</p>' +
        '<p class="km-state-sub">We\'ll let you know as soon as it\'s back.</p>' +
      '</div>' +
    '</div>';
  document.body.appendChild(modal);

  // Cache refs
  var card        = modal.querySelector('.km-card');
  var closeBtn    = modal.querySelector('.km-close');
  var titleEl     = modal.querySelector('#km-title');
  var variantEl   = modal.querySelector('#km-variant');
  var form        = modal.querySelector('.km-form');
  var emailInput  = modal.querySelector('#km-email');
  var errorEl     = modal.querySelector('.km-error');
  var submitBtn   = modal.querySelector('.km-submit');
  var successEl   = modal.querySelector('.km-success');
  var alreadyEl   = modal.querySelector('.km-already');
  var loginWrap   = modal.querySelector('.km-login-wrap');

  // ── Open / close ─────────────────────────────────────────────────────────
  function open(data) {
    activeData   = data;
    lastFocused  = document.activeElement;

    titleEl.textContent   = data.product_title || '';
    variantEl.textContent = (data.variant_title && data.variant_title !== 'Default Title')
      ? data.variant_title : '';

    // Pre-fill email for logged-in customers
    emailInput.value = (CUSTOMER && CUSTOMER.email) ? CUSTOMER.email : '';

    // Reset state
    form.style.display = '';
    successEl.classList.remove('is-on');
    alreadyEl.classList.remove('is-on');
    errorEl.textContent = '';
    emailInput.classList.remove('is-error');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Notify me';
    loginWrap.innerHTML = '';

    modal.style.display = 'flex';
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      setTimeout(function () {
        // Skip focus-to-input if email already pre-filled; focus submit instead
        (CUSTOMER && CUSTOMER.email ? submitBtn : emailInput).focus();
      }, 60);
    });

    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';
  }

  function close() {
    modal.classList.remove('is-open');
    document.removeEventListener('keydown', handleKey);
    document.body.style.overflow = '';
    setTimeout(function () {
      modal.style.display = 'none';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }, 220);
  }

  function handleKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      var focusables = [emailInput, submitBtn, closeBtn].filter(function (n) { return n && !n.disabled; });
      if (!focusables.length) return;
      if (e.shiftKey && document.activeElement === focusables[0]) {
        e.preventDefault(); focusables[focusables.length - 1].focus();
      } else if (!e.shiftKey && document.activeElement === focusables[focusables.length - 1]) {
        e.preventDefault(); focusables[0].focus();
      }
    }
  }

  // ── Wire triggers ────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.notify-me-btn');
    if (!btn) return;
    e.preventDefault();
    var d = btn.dataset;
    open({
      variant_id:    parseInt(d.variantId, 10),
      product_id:    parseInt(d.productId, 10),
      product_title: d.productTitle || '',
      variant_title: d.variantTitle || '',
      product_handle: d.productHandle || '',
    });
  });

  closeBtn.addEventListener('click', close);
  modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
  card.addEventListener('click', function (e) { e.stopPropagation(); });

  // ── Submit ────────────────────────────────────────────────────────────────
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = emailInput.value.trim();
    errorEl.textContent = '';
    emailInput.classList.remove('is-error');

    if (!EMAIL_RE.test(email)) {
      emailInput.classList.add('is-error');
      errorEl.textContent = 'Please enter a valid email address.';
      emailInput.focus();
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting…';

    var payload = {
      email:          email,
      variant_id:     activeData.variant_id,
      product_id:     activeData.product_id,
      product_title:  activeData.product_title,
      variant_title:  activeData.variant_title || 'Default Title',
      product_handle: activeData.product_handle,
    };

    // Include customer_id if logged in (used for metafield write on server)
    if (CUSTOMER && CUSTOMER.id) payload.customer_id = CUSTOMER.id;

    fetch(CFG.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Keplin-Auth': CFG.auth },
      body: JSON.stringify(payload),
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; }); })
      .then(function (resp) {
        if (!resp.ok) {
          var msg = resp.status === 429
            ? 'Too many requests — please try again in a few minutes.'
            : (resp.data && resp.data.error) || 'Something went wrong. Please try again.';
          errorEl.textContent = msg;
          submitBtn.disabled = false;
          submitBtn.textContent = 'Notify me';
          return;
        }

        form.style.display = 'none';

        if (resp.data && resp.data.status === 'already_subscribed') {
          alreadyEl.classList.add('is-on');
        } else {
          successEl.classList.add('is-on');
          loginWrap.innerHTML =
            '<a class="km-login-btn" href="https://keplin-online.com/collections/sale">' +
              'View our products' +
            '</a>';

        }
      })
      .catch(function () {
        errorEl.textContent = 'Couldn\'t reach our server. Please try again.';
        submitBtn.disabled = false;
        submitBtn.textContent = 'Notify me';
      });
  });

// ── Product page: keep ATC + Notify-Me buttons in sync on variant change ───
  // IMPORTANT: the page has MANY [data-nm-page="product"] buttons (product cards
  // below the main product render one too). So we must NOT use a bare
  // document.querySelector('[data-nm-page="product"]') — that can match a card.
  // We scope every lookup to the MAIN product container: <product-info id="MainProduct-…">.
  // Cards are never inside a <product-info>, so this isolates the real PDP button.
  (function () {
    var DEBUG = true;
    function log() {
      if (DEBUG && window.console && console.log) {
        console.log.apply(console, ['[KM-notify]'].concat([].slice.call(arguments)));
      }
    }

    // The MAIN product container (never a card, never a recommendation).
    function getMainScope() {
      return document.querySelector('product-info[id^="MainProduct"]') ||
             document.querySelector('main product-info') ||
             document.querySelector('product-info') ||
             document.querySelector('.product-form') ||
             document;
    }

    function getNotifyBtn(scope) {
      return (scope || getMainScope()).querySelector('[data-nm-page="product"]');
    }

    // Variant JSON is only used to fill the notify button title (may lag a tick).
    function getSelectedVariant(scope) {
      var node = scope.querySelector('variant-selects [data-selected-variant]');
      if (!node) return undefined;
      var txt = (node.textContent || '').trim();
      if (!txt) return null;
      try { return JSON.parse(txt); } catch (e) { return undefined; }
    }

    function apply(reason) {
      var scope     = getMainScope();
      var notifyBtn = getNotifyBtn(scope);
      if (!notifyBtn) { log('apply(' + reason + '): no MAIN notify button, skip'); return; }

      var atcBtn    = scope.querySelector('button[type="submit"][name="add"]');
      var idInput   = scope.querySelector('input[name="id"]');
      var currentId = idInput ? String(idInput.value || '') : '';
      var soldOut   = atcBtn ? atcBtn.hasAttribute('disabled') : false;
      var v         = getSelectedVariant(scope);

      log('apply(' + reason + ') scope=<' + (scope.tagName ? scope.tagName.toLowerCase() : 'document') + '>',
          'currentId=' + currentId,
          'atcFound=' + !!atcBtn,
          'atcDisabled=' + soldOut,
          'variantJSON=' + (v === undefined ? 'MISSING' : (v === null ? 'null/unavailable' : (v.id + ' available=' + v.available))));

      if (!currentId) {                       // no matching variant for the combo
        notifyBtn.style.display = 'none';
        log('  -> unavailable combo: hide notify');
        return;
      }

      if (soldOut) {
        notifyBtn.dataset.variantId = currentId;
        if (v && String(v.id) === currentId) {
          notifyBtn.dataset.variantTitle = (v.title === 'Default Title') ? '' : (v.title || '');
        }
        notifyBtn.style.display = 'block';
        if (atcBtn) atcBtn.style.display = 'none';
        log('  -> SOLD OUT: show notify (variant ' + currentId + '), hide ATC');
      } else {
        notifyBtn.style.display = 'none';
        if (atcBtn) atcBtn.style.removeProperty('display');
        log('  -> IN STOCK: hide notify, show ATC');
      }
    }

    var scheduled = false;
    function schedule(reason) {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; apply(reason || 'mutation'); });
    }

    function boot() {
      var scope = getMainScope();
      var notifyBtn = getNotifyBtn(scope);
      log('boot mainScope=<' + (scope.tagName ? scope.tagName.toLowerCase() : 'document') + '>',
          'notifyBtnInScope=' + !!notifyBtn,
          'totalNotifyBtnsOnPage=' + document.querySelectorAll('[data-nm-page="product"]').length,
          'atcInScope=' + !!scope.querySelector('button[type="submit"][name="add"]'),
          'idInputInScope=' + !!scope.querySelector('input[name="id"]'));
      if (!notifyBtn) { log('boot: no MAIN notify button — is <product-info> present?'); return; }

      apply('boot');

      // Trigger 1: theme's variant event (nudge only; we re-read the DOM).
      document.addEventListener('variant:changed', function () { schedule('variant:changed'); });

      // Trigger 2: theme dispatches a change event on the hidden id input.
      document.addEventListener('change', function (e) {
        if (e.target && e.target.name === 'id') schedule('id-change');
      }, true);

      // Trigger 3: safety net — observe ONLY the main scope (not the whole page,
      // so card mutations never trigger us) for ATC disabled + DOM swaps.
      new MutationObserver(function () { schedule('observer'); }).observe(scope, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['disabled', 'value'],
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  // ── KM-DEBUG — card notify-me visibility investigation ─────────────────────
  // Temporary, verbose, and deliberately global: watches every .notify-me-btn
  // on the page (PDP + every card in every grid/carousel), logs what Liquid
  // rendered into it, and traces *every* later change to its inline style or
  // display attribute, with a stack trace, so we can see which script (if
  // any) is touching it after render. Remove this whole block once resolved.
  (function () {
    var TAG = '[KM-DEBUG]';
    function snapshot(btn) {
      var cs = window.getComputedStyle(btn);
      return {
        title: btn.dataset.productTitle,
        variantId: btn.dataset.variantId,
        liquidAvailable: btn.dataset.kmDebugLiquidAvailable,
        productAvailable: btn.dataset.kmDebugProductAvailable,
        inlineStyle: btn.getAttribute('style'),
        computedDisplay: cs.display,
        context: btn.dataset.kmDebugContext,
      };
    }

    function logAll(label) {
      var btns = document.querySelectorAll('.notify-me-btn');
      console.log(TAG, label, 'count=' + btns.length);
      btns.forEach(function (btn, i) {
        console.log(TAG, label, '#' + i, snapshot(btn));
      });
    }

    function watch(btn, i) {
      // Baseline the moment we see it.
      console.log(TAG, 'watching btn #' + i, snapshot(btn));

      var mo = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.type !== 'attributes') return;
          console.groupCollapsed(
            TAG, 'MUTATION on btn #' + i,
            '(' + (btn.dataset.productTitle || 'unknown product') + ')',
            'attr=' + m.attributeName
          );
          console.log('old value:', m.oldValue);
          console.log('new value:', btn.getAttribute(m.attributeName));
          console.log('snapshot now:', snapshot(btn));
          console.trace(TAG + ' stack for this mutation');
          console.groupEnd();
        });
      });
      mo.observe(btn, { attributes: true, attributeOldValue: true, attributeFilter: ['style', 'class', 'disabled'] });
      return mo;
    }

    function boot() {
      logAll('boot (DOM ready)');
      document.querySelectorAll('.notify-me-btn').forEach(watch);

      // Re-log at a few checkpoints to catch anything that changes things
      // AFTER our own script and after other deferred scripts have run,
      // without needing an observer to have caught it (belt and braces).
      [250, 1000, 2500].forEach(function (ms) {
        setTimeout(function () { logAll('checkpoint +' + ms + 'ms'); }, ms);
      });
      window.addEventListener('load', function () { logAll('window load'); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

})();
